import { render, staticRenderFns } from "./NewArticle.vue?vue&type=template&id=4f45fa48"
import script from "./NewArticle.vue?vue&type=script&lang=ts"
export * from "./NewArticle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports